import { lazy, Suspense } from 'react'
import NewsWidgetPage from '../pages/NewsWidgetPage'

const MarketTrendWidgetPage = lazy(() => import('../pages/MarketTrendWidgetPage'))
const ExchangeRankingWidgetPage = lazy(() => import('../pages/ExchangeRankingWidgetPage'))
const AllRankingWidgetPage = lazy(() => import('../pages/AllRankingWidgetPage'))
const NewsListWidgetPage = lazy(() => import('../pages/NewsListWidgetPage'))
const NewsDetailWidgetPage = lazy(() => import('../pages/NewsDetailWidgetPage'))

const WidgetFallback = () => <div className="h-screen w-screen bg-white" />

const withWidgetSuspense = (element) => <Suspense fallback={<WidgetFallback />}>{element}</Suspense>

export const widgetRoutes = [
  {
    path: '/widgets/market-trend',
    element: withWidgetSuspense(<MarketTrendWidgetPage />)
  },
  {
    path: '/widgets/exchange-ranking',
    element: withWidgetSuspense(<ExchangeRankingWidgetPage />)
  },
  {
    path: '/widgets/stock-ranking',
    element: withWidgetSuspense(<AllRankingWidgetPage />)
  },
  {
    path: '/widgets/news',
    children: [
      {
        index: true,
        element: withWidgetSuspense(<NewsWidgetPage />)
      },
      {
        path: 'list',
        element: withWidgetSuspense(<NewsListWidgetPage />)
      },
      {
        path: ':key',
        element: withWidgetSuspense(<NewsDetailWidgetPage />)
      }
    ]
  }
]
